const POSPrint = ({
  tabletMode,
  cart,
  reciptDetails,
  totalPrice,
  orderType,
  orderId,
  mobile,
  tenderedAmount,
  selectedDiscount,
  apiResponsePrint,
}) => {
  const handlePrintAPI = (reciptDetails = {}, item, fullAddress) => {
    const getStoredReceiptDetails = () => {
      try {
        const raw = sessionStorage.getItem("pos_latest_receipt_details");
        return raw ? JSON.parse(raw) : {};
      } catch (error) {
        console.error("Stored receipt parse error:", error);
        return {};
      }
    };

    const storedReceiptDetails = getStoredReceiptDetails();

    const receiptSourceRaw = Array.isArray(reciptDetails?.response)
      ? reciptDetails.response[0]
      : Array.isArray(reciptDetails)
        ? reciptDetails[0]
        : reciptDetails || {};

    const receiptSource = {
      ...receiptSourceRaw,
      address: receiptSourceRaw?.address || storedReceiptDetails?.address || "",
      phone_no:
        receiptSourceRaw?.phone_no || storedReceiptDetails?.phone_no || "",
      business_name:
        receiptSourceRaw?.business_name ||
        storedReceiptDetails?.business_name ||
        "",
      gst: receiptSourceRaw?.gst || storedReceiptDetails?.gst || "",
      taxCgst:
        receiptSourceRaw?.taxCgst || storedReceiptDetails?.taxCgst || "0",
      taxSgst:
        receiptSourceRaw?.taxSgst || storedReceiptDetails?.taxSgst || "0",
      tag_line1:
        receiptSourceRaw?.tag_line1 ||
        storedReceiptDetails?.tag_line1 ||
        "Visit Again",
    };

    const receipt = {
      business_name:
        receiptSource?.business_name ||
        receiptSource?.businessName ||
        receiptSource?.organization_name ||
        receiptSource?.restaurant_name ||
        receiptSource?.shop_name ||
        receiptSource?.name ||
        item?.business_name ||
        item?.restaurant_name ||
        item?.shop_name ||
        "Restaurant",

      address:
        receiptSource?.address ||
        receiptSource?.restaurant_address ||
        receiptSource?.organization_address ||
        receiptSource?.business_address ||
        receiptSource?.shop_address ||
        receiptSource?.full_address ||
        receiptSource?.store_address ||
        receiptSource?.branch_address ||
        receiptSource?.billing_address ||
        item?.restaurant_address ||
        item?.shop_address ||
        item?.address ||
        "",

      phone_no:
        receiptSource?.phone_no ||
        receiptSource?.phoneNo ||
        receiptSource?.phone ||
        receiptSource?.mobile ||
        receiptSource?.mobile_no ||
        receiptSource?.mobileNo ||
        receiptSource?.restaurant_mobile ||
        receiptSource?.organization_mobile ||
        receiptSource?.shop_mobile ||
        receiptSource?.contact_number ||
        receiptSource?.contactNo ||
        receiptSource?.contact_no ||
        receiptSource?.business_mobile ||
        item?.restaurant_mobile ||
        item?.shop_mobile ||
        item?.phone_no ||
        "",

      gst:
        receiptSource?.gst ||
        receiptSource?.gst_no ||
        receiptSource?.gstNo ||
        receiptSource?.gst_number ||
        receiptSource?.gstNumber ||
        item?.gst_no ||
        item?.gst ||
        "",

      fssaiNo:
        receiptSource?.fssaiNo ||
        receiptSource?.fssai_no ||
        receiptSource?.fssai ||
        receiptSource?.fssai_number ||
        item?.fssai_no ||
        item?.fssaiNo ||
        "",

      taxCgst:
        receiptSource?.taxCgst ||
        receiptSource?.tax_cgst ||
        receiptSource?.cgstRate ||
        item?.tax_cgst_rate ||
        item?.cgstRate ||
        "0",

      taxSgst:
        receiptSource?.taxSgst ||
        receiptSource?.tax_sgst ||
        receiptSource?.sgstRate ||
        item?.tax_sgst_rate ||
        item?.sgstRate ||
        "0",

      tag_line1:
        receiptSource?.tag_line1 ||
        receiptSource?.tagLine1 ||
        receiptSource?.tagline1 ||
        "Visit Again",
    };

    let formattedAddress = "Not available";

    try {
      const addressObj = JSON.parse(item.address_json);
      const values = addressObj?.values || {};

      formattedAddress = [
        values.name,
        values.house_number,
        values.address,
        values.landmark_area,
        values.city,
        values.state,
        values.in_pin_code,
        `Ph: ${values.phone_number}`,
      ]
        .filter(Boolean)
        .join(", ")
        .replace(/,/g, ",&nbsp;");
    } catch (error) {
      console.error("Failed to parse address_json:", error);
    }

    const singleReceiptSection = `
      <div class="container">
        <div class="header">
       <p class="textSizeLarge" style="font-weight: 600;">${receipt.business_name}</p>
${receipt.address ? `<p class="textSizeMid">${receipt.address}</p>` : ""}
${receipt.phone_no ? `<p class="textSizeMid">PH: ${receipt.phone_no}</p>` : ""}
${receipt.gst ? `<p class="textSizeMid">GST NO: ${receipt.gst}</p>` : ""}
${
  receipt.fssaiNo
    ? `<p class="textSizeMid">FSSAI NO: ${receipt.fssaiNo}</p>`
    : ""
}
          <p class="textSizeLarge" style="font-weight: 600;">** INVOICE **</p>
        </div>

        <div class="header2">
          <p class="textSizeMid">Order No: ${
            item.daily_order_id
          } / ${item.orderid}</p>
          <p class="textSizeMid">Order Type: ${item.orderType}</p>

          ${
            !(
              item.customer_name?.toLowerCase() === "default" &&
              (item.customer_mobile === "+91 9999999999" ||
                item.customer_mobile === "+91999999999" ||
                item.customer_mobile === "91999999999" ||
                item.customer_mobile === "999999999")
            )
              ? `
            <p class="textSizeMid">Customer Name: ${item.customer_name}</p>
            <p class="textSizeMid">Customer Mobile: ${item.customer_mobile}</p>
          `
              : ""
          }

          <p class="textSizeMid">Payment Status: ${item.payment_status}</p>  
          <p class="textSizeMid">Payment Mode: ${item.payment_mode}</p>
          <p class="textSizeMid">Order Date: ${item.order_date}</p>

          ${
            item.orderType === "homedelivery"
              ? `<p class="textSizeMid">Delivery Address: ${formattedAddress}</p>`
              : ""
          }

          ${
            item.orderType === "dining"
              ? `<p class="textSizeMid">Table No: ${item.table_no}</p>`
              : ""
          }

          ${
            item.orderType === "room_order"
              ? `<p class="textSizeMid">Room No: ${item.table_no}</p>`
              : ""
          }
        </div>

        <div class="headerTable">
          <table class="order-details" style="border-collapse: collapse;">
            <thead>
              <tr>
                <th class="table-text-center" style="padding-right:5px;">Sr.</th>
                <th class="table-text-center">ITEM</th>
                <th class="table-text-center">QTY</th>
                <th class="table-text-center" style="padding-left:5px; padding-right:5px;">PRC.</th>
                <th class="table-text-center">TTL.</th>
              </tr>
            </thead>
            <tbody>
              ${item.items
                .map((subitem, index) => {
                  let customizationText = "";

                  try {
                    const customization =
                      subitem.customization && subitem.customization !== "{}"
                        ? JSON.parse(subitem.customization)
                        : null;

                    if (Array.isArray(customization)) {
                      const parts = customization.map((cItem) => {
                        const options = Array.isArray(cItem.options)
                          ? cItem.options.join(", ")
                          : "";
                        return ` ${options}`;
                      });

                      customizationText = parts.length
                        ? `<div class="custom-text">(${parts.join(" | ")})</div>`
                        : "";
                    } else {
                      customizationText = "";
                    }
                  } catch {
                    customizationText = `<div class="custom-text">(Invalid customization)</div>`;
                  }

                  return `
                    <tr>
                      <td class="table-text-center">${1 + index}</td>
                      <td class="table-text-center">
                        ${subitem.item_name}
                        ${customizationText}
                      </td>
                      <td class="table-text-center" style="padding-left:5px;">
                        ${subitem.quantity}
                      </td>
                      <td class="table-text-center" style="padding-left:5px; padding-right:5px;">
                        ${parseFloat(subitem.item_price)}
                      </td>
                      <td class="table-text-center">
                        ${parseFloat(subitem.total_price)}
                      </td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </div>

        <div class="headerTotal">
          <div class="flex-row">
            <p class="textSizeMid" style="margin: 0px;">Sub Total :</p>
            <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${
              item.subtotal
            }</p>
          </div>

          ${
            item.discount_amount !== "0.00"
              ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Discount Amount (${
                item.discount_percentage
              }%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
                item.discount_amount,
              ).toFixed(2)}</p>
            </div>
          `
              : ""
          }

          ${
            item.coupon_applied
              ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Coupon discount :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
                item.coupon_code_discount,
              ).toFixed(2)}</p>
            </div>
          `
              : ""
          }

          ${
            Number(reciptDetails.taxCgst) > 0 ||
            Number(reciptDetails.taxSgst) > 0
              ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">CGST (${parseFloat(
                reciptDetails?.taxCgst || "0",
              ).toFixed(1)}%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
                item.tax_cgst,
              ).toFixed(2)}</p>
            </div>
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">SGST (${parseFloat(
                reciptDetails?.taxSgst || "0",
              ).toFixed(1)}%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
                item.tax_sgst,
              ).toFixed(2)}</p>
            </div>
          `
              : ""
          }

          ${
            item.orderType === "homedelivery"
              ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Delivery Fee :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${
                item.delivery_fee
              }</p>
            </div>
          `
              : ""
          }

          <div class="flex-row font-weight-bold">
            <p class="textSizeMid" style="margin: 0px;font-weight: 600;">Total Amount :</p>
            <p class="textSizeMid" style="margin: 0px; text-align: right; font-weight: 600;">Rs. ${
              item.totalOrderPrice
            }</p>
          </div>
          
        </div>

        <div class="header2">
          <p class="textSizeMid">Net Amount : Rs. ${item.totalOrderPrice}</p>
          <p class="textSizeMid">Paid Amount : Rs. ${item.pay_amount}</p>
          <p class="textSizeMid">Due Amount : Rs. ${item.due_amount}</p>
        </div>

        <div class="headerEnd">
          <p class="textSizeMid">Thank you for your purchase!</p>
          <p class="textSizeSmall">* ${reciptDetails?.tag_line1} *</p>
        </div>
      </div>
    `;

    const customerReceiptHTML = `
      <html>
        <head>
          <style>
            @page {
              size: 80mm;
              margin: 0;
            }
            body {
              margin: 0;
              margin-right:15px;
              font-family: Arial, sans-serif;
              font-size: 16px;
              color: black;
            }
            .header {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              text-align: center;
              color: #000;
              line-height: 1.1;
              border-bottom: 1px dashed #000;
              margin-top: 0px;
            }
            .header2 {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: start;
              color: #000;
              line-height: 1.5;
              border-bottom: 1px dashed #000;
              margin-top: 0px;
              padding-bottom: 0px;
            }
            .headerTable {
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: start;
              color: #000;
              line-height: 1.2;
              border-bottom: 1px dashed #000;
              padding: 0;
              margin: 0;
            }
            .headerTotal {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: left;
              color: #000;
              line-height: 1.5;
              border-bottom: 1px dashed #000;
              padding-bottom: 5px;
              padding-top: 5px;
              padding:0px;
            }
            .flex-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }
            .headerEnd {
              text-align: center;
              color: #000;
              padding-bottom: 0px;
            }
            .textSizeLarge {
              font-size: 16px;
              margin: 1px;
              padding: 1px;
            }
            .textSizeMid {
              font-size: 12px;
              margin: 0px;
              padding: 0px;
            }
            .textSizeSmall {
              font-size: 9px;
              margin: 1px;
              padding: 1px;
            }
            .order-details { width: 100%; border-collapse: collapse; }
            .order-details th,
            .order-details td {
              padding: 0px;
              padding-top: 5px;
              padding-bottom: 5px;
              font-size: 12px;
              text-align: left;
              vertical-align: top;
            }
            .table-text-center { text-align: center; }
            .page-break {
              page-break-after: always;
            }
          </style>
        </head>
        <body>
          ${singleReceiptSection}
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(customerReceiptHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <>
      <button
        id="pos-print-btn"
        onClick={() => {
          if (Array.isArray(apiResponsePrint)) {
            if (apiResponsePrint.length > 0) {
              handlePrintAPI(reciptDetails, apiResponsePrint[0], "");
            } else {
              console.error("apiResponsePrint is an empty array.");
            }
          } else if (
            typeof apiResponsePrint === "object" &&
            apiResponsePrint !== null
          ) {
            handlePrintAPI(reciptDetails, apiResponsePrint, "");
          } else {
            console.error("apiResponsePrint is not valid.");
          }
        }}
        style={{ height: "120px", width: "250px" }}
        className={
          tabletMode
            ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
            : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
        }
      >
        PRINT
      </button>
    </>
  );
};

export default POSPrint;
